import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { add_to_cart, decrease_cart } from "../../state/cartSlice";
import styled from "styled-components";
import VegICO from "../../assets/Veg-Logo-2.png";
import NonVegICO from "../../assets/New-Non-Logo.png";

const Div1 = styled.div`
	display: flex;
	flex-wrap: nowrap;
`;

const Div2 = styled.div`
	display: flex;
	margin-top: -20px;
	z-index: 1;
	background: #fa7171;
	border-radius: 20px;
`;

const Image = styled.img`
	width: 15px;
	height: 15px;
`;

const Dish = ({ dish }) => {
	const cart = useSelector((state) => state.cart.value);
	const dispatch = useDispatch();
	const [quantity, setQuantity] = useState(0);
	const [show, setShow] = useState(dish.description.length > 60);

	useEffect(() => {
		let t_dish = cart.find((c) => c.id === dish.id);
		if (t_dish) setQuantity(t_dish.quantity);
		else setQuantity(0);
	}, [cart, dish]);

	const cartHandle = (mode) => {
		if (mode === "plus") dispatch(add_to_cart(dish));
		else dispatch(decrease_cart(dish));
	};

	return (
		<div className="row fda_section_row bor">
			<div className="col-5 men">
				<img className="img_p" src={dish.image} alt="Dish" />
				{quantity === 0 ? (
					<button
						type="button"
						className="btn btn-sm bttn3"
						onClick={cartHandle.bind(this, "plus")}
					>
						Add
					</button>
				) : (
					<Div1 className="row">
						<Div2>
							<button
								type="button"
								className="btn btn-sm bttn4"
								onClick={cartHandle.bind(this, "minus")}
							>
								-
							</button>
							<span className="over2">{quantity}</span>
							<button
								type="button"
								className="btn btn-sm bttn4"
								onClick={cartHandle.bind(this, "plus")}
							>
								+
							</button>
						</Div2>
					</Div1>
				)}
			</div>
			<div className="col-7 ">
				<span>
					{dish.type === "Vegetarian" ? (
						<Image src={VegICO} alt={dish.type} />
					) : (
						<Image src={NonVegICO} alt={dish.type} />
					)}
					{dish.tags && <span className="badge">{dish.tags}</span>}
				</span>
				<span className="product_title">{dish.name}</span>
				<span className="food_detail1">
					{show ? (
						<>
							{dish.description.substring(0, 60)}...
							<button
								className="btn btn-link readm"
								style={{ display: "inline" }}
								onClick={() => setShow(false)}
							>
								<b>Read more</b>
							</button>
						</>
					) : (
						dish.description
					)}
				</span>
				<span className="product_price">
					<i className="fa fa-inr"></i> {dish.price}
				</span>
			</div>
		</div>
	);
};

export default Dish;
